export default __webpack_public_path__ + "2f3adb62c7744590f47eacd5704e3ebd.woff";